import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home as HomeIcon, List, Plus, Heart, BarChart2 } from 'lucide-react';

const Layout = ({ children }) => {
  const loc = useLocation();
  const [hideTabs, setHideTabs] = useState(false);
  const active = (p) => loc.pathname === p ? 'text-indigo-600' : 'text-gray-400';
  const logoUrl = "https://cdn-icons-png.flaticon.com/512/4345/4345564.png";

  // Automatically detect focus on any input/textarea to hide tabs
  useEffect(() => {
    const handleFocus = (e) => {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
        setHideTabs(true);
      }
    };
    const handleBlur = () => setHideTabs(false);

    window.addEventListener('focusin', handleFocus);
    window.addEventListener('focusout', handleBlur);
    
    return () => {
      window.removeEventListener('focusin', handleFocus);
      window.removeEventListener('focusout', handleBlur);
    };
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col font-sans">
      {/* Desktop Nav remains unchanged */}
      <nav className="hidden md:flex justify-between items-center px-12 py-4 bg-white shadow-sm sticky top-0 z-50">
        <Link to="/" className="flex items-center gap-3">
          <img src={logoUrl} alt="Logo" className="w-9 h-9 object-contain" />
          <h1 className="text-xl font-black text-gray-800 tracking-tighter">NOTEONQUICK</h1>
        </Link>
        <div className="flex gap-8 font-bold text-xs tracking-widest items-center">
          <Link to="/" className={active('/')}>HOME</Link>
          <Link to="/all-notes" className={active('/all-notes')}>ALL NOTES</Link>
          <Link to="/wishlist" className={active('/wishlist')}>WISHLIST</Link>
          <Link to="/stats" className={active('/stats')}>STATS</Link>
          <Link to="/editor" className="bg-indigo-600 text-white px-6 py-2 rounded-full shadow-lg">QUICK NOTE</Link>
        </div>
      </nav>

      <main className="flex-1 max-w-3xl w-full mx-auto p-5 pb-32 md:pb-10">{children}</main>

      {/* MOBILE TABS: Conditional Rendering based on hideTabs */}
      <div className={`md:hidden fixed bottom-0 left-0 right-0 bg-white border-t flex justify-around items-center h-20 px-2 z-50 shadow-2xl transition-transform duration-300 ${hideTabs ? 'translate-y-full opacity-0' : 'translate-y-0 opacity-100'}`}>
        <Link to="/" className={`flex flex-col items-center ${active('/')}`}><HomeIcon size={22}/><span className="text-[10px] mt-1 font-bold">Home</span></Link>
        <Link to="/all-notes" className={`flex flex-col items-center ${active('/all-notes')}`}><List size={22}/><span className="text-[10px] mt-1 font-bold">Notes</span></Link>
        <Link to="/editor" className="relative -top-10 bg-indigo-600 p-5 rounded-full text-white shadow-2xl border-[6px] border-slate-50 active:scale-90 transition-transform"><Plus size={30} strokeWidth={3}/></Link>
        <Link to="/wishlist" className={`flex flex-col items-center ${active('/wishlist')}`}><Heart size={22}/><span className="text-[10px] mt-1 font-bold">Wish</span></Link>
        <Link to="/stats" className={`flex flex-col items-center ${active('/stats')}`}><BarChart2 size={22}/><span className="text-[10px] mt-1 font-bold">Stats</span></Link>
      </div>
    </div>
  );
};

export default Layout;